module.exports = __webpack_public_path__ + "img/can-not-be-used-ingredients-icon.077f0dfb.svg";